
import { Component, MixedVue } from "@/vue";

@Component({
  name: "ThirdStep",
})
export default class ThirdStep extends MixedVue {
  async refreshLicense() {
    // We could just reload the license here, but the user
    // might be in a weird place. (E.g. the 403 page)
    // Reload the whole app, just to be safe.
    history.pushState({}, null, window.location.origin);
    window.location.reload();
  }
}
